import env from "./env"

/**
 * Stripe Pricing Table embed config for /choose-plan.
 * Values come from src/lib/env.js (not process.env) so a stale
 * BLINDINSIGHT_STRIPE_PRICING_TABLE_ID in your shell or .env.local
 * cannot override the table id bundled from this repo.
 */
export function getStripePricingTableEmbedConfig() {
  return {
    publishableKey: env.BLINDINSIGHT_STRIPE_PUBLISHABLE_KEY,
    pricingTableId: env.BLINDINSIGHT_STRIPE_PRICING_TABLE_ID,
  }
}
